// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2-gQO","fileBtn":"File_fileBtn__QhZ5S","closeBtn":"File_closeBtn__1odGi","fileSelected":"File_fileSelected__27biM","disabled":"File_disabled__2omgB"};